import { useEffect, useState } from 'react';
import {
  selectAlarms,
  selectTimeWarningAlarms,
} from '../spectrasWebSocketServer/spectrasWebSocketServerSlice';

import { Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useAppSelector } from '../../app/hooks';
import { useAlarmSettings } from 'features/alarms/api/getAlarmSettings';

import useSound from 'use-sound';

const NotificationBadge = () => {
  const { data: alarmSettings } = useAlarmSettings({});

  const [playSound] = useSound('/audio-alarm.wav');
  const alarms = useAppSelector(selectAlarms);
  const timeWarningAlarms = useAppSelector(selectTimeWarningAlarms);

  const combinedAlarms = [...(alarms || []), ...timeWarningAlarms];

  const [previousAlarmLength, setPreviousAlarmLength] = useState<number>(0);

  useEffect(() => {
    if (!alarms || alarms.length === 0 || !alarmSettings) return;

    if (previousAlarmLength > alarms.length) {
      setPreviousAlarmLength(alarms.length);
      return;
    }

    if (alarmSettings.alarm_audio) {
      playSound();
      setTimeout(playSound, 3050);
    }
    setPreviousAlarmLength(alarms.length);
    //eslint-disable-next-line
  }, [alarms]);

  return (
    <Badge badgeContent={combinedAlarms.length} max={25} color='error'>
      <NotificationsIcon />
    </Badge>
  );
};

export default NotificationBadge;
